import { render } from "./available-tab.vue?vue&type=template&id=39171378&scoped=true"
import script from "./available-tab.vue?vue&type=script&lang=js"
export * from "./available-tab.vue?vue&type=script&lang=js"

import "./available-tab.vue?vue&type=style&index=0&id=39171378&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39171378"]])

export default __exports__